import { collect } from "collect.js";
import { PROMOTION_TYPES } from "../../services/exports/Constants";
import useStore from "../global/useStore";

export default function useLoyaltyProgram() {
  const { company } = useStore()?.initialData;
  const data = collect(company?.promotions ?? []).first(
    (item) => item.type === PROMOTION_TYPES.LOYALTY_PROGRAM
  );

  return {
    loyalty: data,
    hasLoyaltyPromotion: !!data,
    reward: data?.reward,
    rewardThreshold: data?.details?.reward_threshold,
    isPerEligibleItem: data?.details?.is_per_item,
  };
}
